// src/lib/gtag.js
export const GTAG_ID = "AW-17491861595"; // Google Ads
export const GA4_ID = "G-L6LG9DZ8DV"; // Google Analytics 4

let loaded = false;

// Betölti a gtag scriptet – KIZÁRÓLAG süti-elfogadás után szabad hívni
export function loadGtag() {
  if (typeof window === "undefined") return;

  // csak egyszer fusson
  if (loaded) return;
  loaded = true;

  // 1. dataLayer + gtag definiálás
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  // 2. már most toljuk be az init hívásokat a dataLayer-be
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID);
  window.gtag("config", GTAG_ID);

  // 3. külső script betöltése
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(s);
}

// Dinamikus phone_conversion_number config
export function setPhoneConversionNumber(conversionId, phoneNumber) {
  if (!window.gtag) return;
  window.gtag("config", conversionId, {
    phone_conversion_number: phoneNumber,
  });
}

export function setFormConversion(conversionId, phoneNumber) {
  if (!window.gtag) return;
  window.gtag("config", conversionId, {
    phone_conversion_number: phoneNumber,
  });
}

// Általános conversion event küldés
export function gtagConversion(conversionId, params = {}) {
  if (!window.gtag) return;
  window.gtag("event", "conversion", {
    send_to: conversionId,
    ...params,
  });
}

// Telefon kattintás tracking
export function trackPhoneClick(conversionId, phoneNumber) {
  setPhoneConversionNumber(conversionId, phoneNumber);
  gtagConversion(conversionId, { phone_number: phoneNumber });
}
